import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import './SpeakerInfoSection.scss';

export default function BackgroundImageSection(props) {
  let row = `d-flex justify-content-${props.imgPosition === 'left' ? 'end': 'start'}`;

  return (
    <section className={classNames(`section section-speaker-info section-speaker-info-${props.speaker} d-flex flex-column`, props.className)}>
      <div className="section-image background-cover background-image-center background-image-mobile d-lg-none" />
      <div className={classNames(`section-speaker-info-image section-speaker-info-image-${props.speaker} my-auto`)}>
        <div className={classNames(`speaker-background speaker-background-${props.speaker}`)}/>
        <Container>
          <Row className={row}>
            <Col className={props.colClass}>
              {props.children}
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}

BackgroundImageSection.defaultProps = {
  overlayColor: "white",
  colClass: "col-12 col-lg-6 col-xl-5"
}
